import { addSeconds, format } from 'date-fns';
import { EVENT_TYPES } from '../constants/eventTypes';

export const formattedSecondsTime = (seconds="00",formatValue="ss") => {
    var helperDate = addSeconds(new Date(0), seconds);
    return format(helperDate, formatValue);
}

export const formattedFlightsUntil = (values,type='end') => {

    if (values == undefined) return "00/00/0000";
    const [{ start, end }] = values;
    const result = type==='end' ? end : start
    return format(Date.parse(result), 'dd/MM/yyyy');
}

export const formattedFlights = (values, type='end', lang='es') => {
    if (values == undefined) return "00/00/0000";
    const [{ start, end }] = values;
    const result = type==='end' ? end : start
    return new Intl.DateTimeFormat(lang, { day:'numeric', month:'long', hour: '2-digit',  minute: '2-digit'}).format(Date.parse(result));

}

export const CountDown = (flights) => {
    const [{ start, end }] = flights;

    const total = Date.parse(start) - Date.parse(new Date());
    const seconds = Math.floor( (total/1000) % 60 );
    const minutes = Math.floor( (total/1000/60) % 60 );
    const hours = Math.floor( (total/(1000*60*60)) % 24 );
    const days = Math.floor( total/(1000*60*60*24) );
  
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    }
}

export const formattedSportFlights = (values, type='start', lang='es') => {
    if ( !values ) return ["00/00", "00:00"];

    const [{ start, end }] = values;
    const result = type === 'end' ? end : start;

    const dateTime = new Intl.DateTimeFormat(lang, {
        hourCycle: "h12",
        day:'2-digit',
        month:'2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).format(Date.parse(result));

    return dateTime.split(',');
}


/**
 * Validate ContentOVerViewLive 's event type
 *
 * @param  {*}         flights  Object with starDate and endDate 
 * @param  {*}         live     Prop
 * @return {String}             Return eventType
 */

export const eventTypeValidate = (flights, live) => {
    const [{ start, end }] = flights;
    const start_Minor_Now = Date.parse(start) <= Date.parse(new Date());
    const end_Major_Now = Date.parse(end) >= Date.parse(new Date());
    let result='';
  

    if(live && (( start_Minor_Now && !end ) || (start_Minor_Now && end_Major_Now)))
        result = EVENT_TYPES.IS_LIVE;
    else if(!start_Minor_Now )
        result = EVENT_TYPES.COMING_SOON
    else if (!live && (start_Minor_Now && (!end || end_Major_Now)))
        result = EVENT_TYPES.ON_DEMAND
    else
        result = EVENT_TYPES.OFFLINE;
        
    return result;

}

export const  formatDate = (date) =>{
  var year = date.getUTCFullYear();
  var month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
  var day = ("0" + date.getUTCDate()).slice(-2);
  var hours = ("0" + date.getUTCHours()).slice(-2);
  var minutes = ("0" + date.getUTCMinutes()).slice(-2);
  var seconds = ("0" + date.getUTCSeconds()).slice(-2);
  return year + month + day + "T" + hours + minutes + seconds + "Z";
}

export const formatDates = (dates) => {
  const start = new Date(dates?.[0]?.flights?.[0]?.start);
  const end = new Date(dates?.[0]?.flights?.[0]?.end);

  return {
    start: formatDate(start),
    end: formatDate(end),
  };
};